import { CommonService } from 'dashboard-services/services';

export const isFileTypeSupportedForPreview = fileName => {
  if(!fileName) {
    return false;
  }
  const parsedFileName = String(fileName).toLowerCase()
  return (
    parsedFileName.endsWith(".pdf") || 
    parsedFileName.endsWith(".html") || 
    parsedFileName.endsWith(".csv") || 
    parsedFileName.endsWith(".txt") || 
    parsedFileName.endsWith(".md") || 
    parsedFileName.endsWith(".ftl") ||
    parsedFileName.endsWith(".py") || 
    parsedFileName.endsWith(".sh") || 
    parsedFileName.endsWith(".json") || 
    parsedFileName.endsWith(".ipynb") || 
    parsedFileName.endsWith(".js") ||
    parsedFileName.endsWith(".sql") ||
    CommonService.isSupportedImage(parsedFileName)
  )
}